import { formatMonthYearCategory } from '../../../helpers/date';

const getReportedStreamsChartOptions = categories => {
  const axisTextColor = localStorage.getItem('appMode') === 'dark' ? '#ffffff' : '#000000';
  const themeFont =
    getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim() || 'Arial, sans-serif';
  const themeFontWeight = getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight').trim() || '400';
  const inverse = getComputedStyle(document.body).getPropertyValue('--bs-inverse').trim();
  const inverseRgb = getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb').trim();

  const singleSeriesXFormatter = (value, opts) => {
    const names = opts?.w?.globals?.seriesNames;
    if (Array.isArray(names) && names.length === 1 && names[0]) {
      return names[0];
    }
    return formatMonthYearCategory(value);
  };

  return {
    chart: { type: 'area', toolbar: { show: false } },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 2 },
    grid: { borderColor: '#ddd' },
    xaxis: {
      type: 'category',
      categories,
      axisTicks: { show: true, borderType: 'solid', color: `rgba(${inverseRgb}, .25)`, height: 6 },
      axisBorder: { show: true, color: `rgba(${inverseRgb}, .25)`, height: 1 },
      labels: {
        formatter: value => formatMonthYearCategory(value),
        style: { colors: axisTextColor, fontSize: '12px', fontFamily: themeFont, fontWeight: themeFontWeight },
      },
      tooltip: {
        enabled: false,
        formatter: singleSeriesXFormatter,
      },
    },
    yaxis: {
      labels: {
        formatter: value => Math.round(value),
        style: { colors: axisTextColor, fontSize: '12px', fontFamily: themeFont, fontWeight: themeFontWeight },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      custom: ({ series, dataPointIndex, w }) => {
        const names = w.globals.seriesNames;
        const cats = w.globals.categoryLabels;
        const label = cats[dataPointIndex];
        const title =
          Array.isArray(names) && names.length === 1 && names[0]
            ? names[0]
            : formatMonthYearCategory(label);
        let items = '';
        names.forEach((name, i) => {
          const val = series[i][dataPointIndex];
          if (val < 1) return;
          const c = w.globals.colors[i];
          items += `<div style="display:flex;align-items:center;gap:4px;padding:2px 6px;font-size:13px;white-space:nowrap;font-family:${themeFont};">
            <span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${c};flex-shrink:0;"></span>
            <span>${name}</span>
            <span style="font-weight:600;margin-left:2px;">${val}</span>
          </div>`;
        });
        return `<div style="display:flex;flex-wrap:wrap;gap:2px;padding:6px 8px;max-width:600px;">
          <div style="width:100%;font-weight:700;font-size:12px;margin-bottom:2px;font-family:${themeFont};">${title}</div>
          ${items}
        </div>`;
      },
    },
    legend: {
      show: true,
      fontFamily: themeFont,
      labels: { colors: inverse || axisTextColor },
      showForSingleSeries: true,
    },
  };
};

export default getReportedStreamsChartOptions;
